var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "",
        width: "408px",
        loading: _vm.loading,
        height: "auto",
        top: _vm.top,
      },
      on: { success: _vm.sure },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c("div", { staticClass: "feisuApply" }, [
        _c("div", { staticClass: "feisuApplyTitle" }, [_vm._v("扫码绑定")]),
        _c("div", { staticClass: "feisuApplyTips" }, [
          _vm._v(" 请使用 "),
          _c("span", { staticStyle: { color: "#2c3242" } }, [
            _vm._v("【飞书】"),
          ]),
          _vm._v(" 移动端扫描二维码 "),
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "new-scan-qrcode-container",
          },
          [
            _vm.showFeiShuQr
              ? _c("div", {
                  staticStyle: { width: "182px", height: "182px" },
                  attrs: { id: "feisuApply_feisu_login_container" },
                })
              : _vm._e(),
          ]
        ),
        _c("div", { ref: "iframe", staticStyle: { display: "none" } }),
      ]),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }